import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ logoSrc, homeTo = '/' }) => (
  <div className="logo-area">
    <Link to={`${process.env.PUBLIC_URL || ''}${homeTo}`}>
      <img src={logoSrc} alt="cmu-logo" />
    </Link>
  </div>
);

export default Logo;
